import { render, staticRenderFns } from "./TelemetryEventNavigationSpeedLimitOverlay.vue?vue&type=template&id=d0ef85e2&"
import script from "./TelemetryEventNavigationSpeedLimitOverlay.vue?vue&type=script&lang=js&"
export * from "./TelemetryEventNavigationSpeedLimitOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports